module.exports = __webpack_public_path__ + "img/share_square.89773ea4.png";